import React from "react";
import ReactECharts from "echarts-for-react";

interface HourlyUsageChartProps {
  hours: string[];
  filteredHourlyData: number[];
}

const HourlyUsageChart: React.FC<HourlyUsageChartProps> = ({
  hours,
  filteredHourlyData,
}) => {
  const options = {
    tooltip: {
      trigger: "axis",
      backgroundColor: "#181B25",
      borderWidth: 0,
      textStyle: {
        color: "#fff",
        fontSize: 12,
      },
    },
    xAxis: {
      type: "category",
      data: hours.slice(0, filteredHourlyData.length),
      axisLabel: {
        color: "#181B25",
        fontSize: 11,
        fontWeight: 400,
      },
    },
    yAxis: {
      type: "value",
      name: "Consumption",
      axisLabel: {
        formatter: "{value}",
        color: "#5F6368",
        fontSize: 9,
        fontWeight: 400,
        lineHeight: 11,
        letterSpacing: 0.2,
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: "#e0e0e0",
          type: "dashed",
        },
      },
    },
    grid: {
      left: "5%",
      right: "5%",
      bottom: "5%",
      containLabel: true,
    },
    series: [
      {
        name: "Hourly Consumption",
        type: "line",
        data: filteredHourlyData,
        lineStyle: {
          color: "#1976d2",
          width: 2,
        },
        itemStyle: {
          color: "#1976d2",
        },
        symbol: "circle",
        symbolSize: 6,
      },
    ],
    toolbox: {
      feature: {
        saveAsImage: {},
        dataView: {},
        restore: {},
        magicType: { type: ["line", "bar"] },
        brush: { type: ["rect", "polygon", "clear"] },
        dataZoom: {},
      },
    },
    dataZoom: [
      {
        type: "inside",
      },
    ],
  };

  return <ReactECharts option={options} />;
};

export default HourlyUsageChart;
